module.exports = __webpack_public_path__ + "img/login_decorate.96df5ac5.png";